"use client";
import { Box } from "@chakra-ui/react";
import CardsList from "@/components/cardsList";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import { REVIEW_CONSTANTS, NOTE_CONSTANT } from "./constants";

const ReviewComp = () => {
  const { title, list } = REVIEW_CONSTANTS;
  const textVariant = useTextVariant();
  return (
    <Box>
      <CardsList
        columns={{ base: 1, sm: 2 }}
        list={list}
        hoverEffect
        hover={{
          bgColor: "white",
          boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
          border: "1px solid #9ECFFF",
          borderRadius: "12px",
        }}
        spacing={{ base: 8, md: 12 }}
        title={title}
      />
      <Box
        mt={6}
        p={4}
        borderRadius={"22px"}
        bgColor="gray.100"
        border="1px solid"
        borderColor="gray.200"
        color="gray.600"
        fontStyle="italic"
        boxShadow={"0px 4px 20px rgba(0, 0, 0, 0.1)"}
      >
        <Text variant={textVariant} as="span" fontWeight="bold">
          Note :
        </Text>{" "}
        <Text variant={textVariant} as="span">
          {NOTE_CONSTANT.content}
        </Text>
      </Box>
    </Box>
  );
};

export default ReviewComp;
